import { MasterDetailListEntry } from "@sdbn/common";

export class Pager implements MasterDetailListEntry {
  id: number;
  nbr: string;
  serial: string;

  constructor(pager: any) {
    this.id = pager.id;
    this.nbr = pager.nbr;
    this.serial = pager.serial;
  }

  public get listTitle(): string {
    return '#' + this.nbr;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}
